import React from 'react';

import { STEPS } from '../../containers/Wizard/wizardReducer';
import { MID_FINISH_STEP_ID } from '../../containers/Wizard/wizardIds';
import styles from './WizardSidebar.module.css';

const WizardSidebar = ({ steps, selectedStep, showMidFinishStep }) => {
    const selectedStepIndex = steps.findIndex((step) => step === selectedStep);
    const midFinishStepIndex = steps.findIndex((step) => step === MID_FINISH_STEP_ID);
    return (
        <div className={styles.sidebarContainer}>
            {steps.map((step, index) => {
                if (
                    (showMidFinishStep && midFinishStepIndex < index) ||
                    (!showMidFinishStep && midFinishStepIndex === index)
                ) {
                    return null;
                }

                return (
                    <div
                        key={`category_${step}`}
                        className={`${styles.categoryContainer} ${
                            step === selectedStep ? styles.selectedCategory : ''
                        }`}>
                        <span className={styles.relative}>
                            <span className={styles.imgContainer}>
                                <img src={STEPS[step].ICON} alt="" />
                            </span>
                            {index < selectedStepIndex && (
                                <span className={styles.checkedCategory}>
                                    <i className="fa fa-check" />
                                </span>
                            )}
                        </span>
                        <span
                            className={
                                STEPS[step].OPTIONAL
                                    ? styles.optionalCategoryTextContainer
                                    : styles.categoryTextContainer
                            }>
                            <span className={styles.categoryNameContainer}>{STEPS[step].NAME}</span>
                            {STEPS[step].OPTIONAL && <span className={styles.optionalText}>(optional)</span>}
                        </span>
                    </div>
                );
            })}
        </div>
    );
};

export default React.memo(WizardSidebar);
